import React from 'react';
import { Svg, Path } from "react-native-svg-web";


export const CircleTick = ({
  className,
  color = '#333333',
  size = '24px',
  style }) => /*#__PURE__*/

React.createElement(Svg, {

  className: className,
  style: style,
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

React.createElement(Path, {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.7071 9.29289C17.0976 9.68342 17.0976 10.3166 16.7071 10.7071L11 16.4142L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929L11 13.5858L15.2929 9.29289C15.6834 8.90237 16.3166 8.90237 16.7071 9.29289Z",
  fill: color }), /*#__PURE__*/

React.createElement(Path, {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 20C16.4184 20 20 16.4184 20 12C20 7.58157 16.4184 4 12 4C7.58157 4 4 7.58157 4 12C4 16.4184 7.58157 20 12 20ZM22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12Z",
  fill: color }));